import React, { useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import VehicleCard from "../../cards/VehicleCard/VehicleCard";
import vehiclesData from "../../../data/vehiclesData";
import "./VehicleSection.css";

export default function VehicleSection() {
    const sliderRef = useRef(null);

    const scrollByAmount = (direction) => {
        if (!sliderRef.current) return;

        const firstChild = sliderRef.current.firstChild;
        const cardWidth = firstChild
            ? firstChild.getBoundingClientRect().width
            : 280;

        const scrollAmount = cardWidth * 1.5;

        sliderRef.current.scrollBy({
            left: direction === "right" ? scrollAmount : -scrollAmount,
            behavior: "smooth"
        });
    };

    return (
        <section className="section-spacing vehicles-section">
            <Container fluid>
                <Row className="align-items-center">
                    {/* Title column - 2 of 12 on large screens, full width on small */}
                    <Col xs={12} lg={2}>
                        <div className="rotate-title">
                            <SectionTitle
                                subtitle="Our"
                                title="Vehicles"
                                align="left"
                            />
                        </div>
                    </Col>

                    {/* Slider column - 10 of 12 on large screens, full width on small */}
                    <Col xs={12} lg={10}>
                        <div className="vehicles__slider-wrapper">
                            <div className="vehicles__slider" ref={sliderRef}>
                                {vehiclesData.map((v) => (
                                    <div className="vehicles__item" key={v.id}>
                                        <VehicleCard
                                            title={v.title}
                                            imageSrc={v.imageSrc}
                                            href={v.href}
                                            background={v.background}
                                        />
                                    </div>
                                ))}
                            </div>

                            {/* Centered controls below slider */}
                            <div className="vehicles__controls">
                                <button
                                    type="button"
                                    className="vehicles__arrow"
                                    onClick={() => scrollByAmount("left")}
                                    aria-label="Scroll vehicles left"
                                >
                                    ‹
                                </button>
                                <button
                                    type="button"
                                    className="vehicles__arrow"
                                    onClick={() => scrollByAmount("right")}
                                    aria-label="Scroll vehicles right"
                                >
                                    ›
                                </button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
